<template>
  <el-dialog
    class="radish-dia"
    title="是否需要将人选加入收藏夹"
    width="400px"
    top="70px"
    :modal="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="dialogVisible"
  >
    <div slot="title" style="font-size:16px;font-weight:bold;">加入收藏夹</div>
    <div style="display:flex;margin-bottom:5px;">
      <el-input v-model="keywords" size="mini" placeholder="输入搜索内容并点击搜索" style="width:100%;margin-right:10px;">
      </el-input>
      <el-button size="mini" type="text" @click="searchFav">搜索</el-button>
      <el-button size="mini" type="text" @click="clear">清空</el-button>
    </div>
    <div class="radish-dia-body">
      <el-checkbox-group v-model="fids" style="font-size:14px;">
        <div v-for="(favs, k) in favOptions" :key="k">
          <div class="fav-dia-label">
            <span>{{ typeMap[k] }}</span>
            <i v-if="(k === 'team' && isLeader) || k === 'me'" class="el-icon-circle-plus-outline add-fav-icon" @click="addChildFav({_id: k})"></i>
          </div>
          <div v-if="addingId === k" style="display:flex;padding:0 10px 0 20px;">
            <el-input v-model="favName" size="mini" placeholder="请输入" style="margin-right:10px;"></el-input>
            <el-button size="mini" type="text" @click="addFav({type: k})">确定</el-button>
            <el-button size="mini" type="text" @click="addingId = ''">取消</el-button>
          </div>
          <div v-for="(fav, k1) in favs" :key="k1">
            <div v-if="fav.children">
              <div class="fav-dia-label" style="padding-left:20px;">
                <el-checkbox :label="fav.value">
                  <span>{{ fav.label }}</span>
                </el-checkbox>
                <i v-if="fav.account == loginAccount" class="el-icon-circle-plus-outline add-fav-icon" @click="addChildFav({_id: fav.value})"></i>
              </div>
              <div v-if="addingId === fav.value" style="display:flex;padding:0 10px 0 40px;">
                <el-input v-model="favName" size="mini" placeholder="请输入" style="margin-right:10px;"></el-input>
                <el-button size="mini" type="text" @click="addFav({_id: fav.value, type: k})">确定</el-button>
                <el-button size="mini" type="text" @click="addingId = ''">取消</el-button>
              </div>
              <div v-for="(cfav, k2) in fav.children" :key="k2" class="fav-dia-label" style="padding-left:40px;">
                <el-checkbox :label="cfav.value">
                  {{ cfav.label }}
                </el-checkbox>
              </div>
            </div>
            <div v-else>
              <div class="fav-dia-label" style="padding-left:20px;">
                <el-checkbox :label="fav.value">
                  {{ fav.label }}
                </el-checkbox>
                <i v-if="fav.account == loginAccount" class="el-icon-circle-plus-outline add-fav-icon" @click="addChildFav({_id: fav.value})"></i>
              </div>
              <div v-if="addingId === fav.value" style="display:flex;padding:0 10px 0 40px;">
                <el-input v-model="favName" size="mini" placeholder="请输入" style="margin-right:10px;"></el-input>
                <el-button size="mini" type="text" @click="addFav({_id: fav.value})">确定</el-button>
                <el-button size="mini" type="text" @click="addingId = ''">取消</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-checkbox-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="handleConfirm">不加收藏夹直接上传</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确定加入收藏夹</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data: function() {
    return {
      dialogVisible: false,
      keywords: '',
      favAll: {},
      favOptions: {},
      fids: [],
      favName: '',
      activeTypes: [],
      typeMap: {
        team: '团队收藏夹',
        me: '个人收藏夹',
        share: '分享给我的'
      },
      activeNames: ['team', 'me', 'share'],
      loginAccount: '',
      isLeader: false,
      addingId: ''
    }
  },
  props: {
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  mounted() {
    this.loginAccount = app.user.account
    this.isLeader = app.user.角色 && app.user.角色.includes('团队长')
  },
  methods: {
    show: function() {
      this.fids = []
      this.clear()
      this.dialogVisible = true
    },
    loadFavs: async function() {
      const res = await app.service('radish').listFavoritesTree()
      if (res.status == 'success') {
        const favOptions = {}
        for (const key in res.data) {
          const favs = res.data[key]
          favOptions[key] = []
          favs.forEach(fav => {
            const item = { label: fav.name, value: fav._id, account: fav.account }
            if (fav.children) {
              const children = []
              fav.children.forEach(cfav => {
                const citem = { label: cfav.name, value: cfav._id, account: cfav.account }
                children.push(citem)
              })
              item.children = children
            }
            favOptions[key].push(item)
          })
        }
        this.favOptions = favOptions
        this.favAll = JSON.parse(JSON.stringify(favOptions))
      }
      // console.log(this.favOptions)
    },
    searchFav: function() {
      this.favName = ''
      this.addingId = ''
      if (this.keywords) {
        const res = {}
        for (const k in this.favAll) {
          const favs = this.favAll[k]
          res[k] = []
          favs.forEach(fav => {
            const item = { label: fav.label, value: fav.value, account: fav.account }
            if (fav.children) {
              item.children = fav.children.filter(f => f.label.indexOf(this.keywords) != -1)
            }
            if ((item.children && item.children.length > 0) || fav.label.indexOf(this.keywords) != -1) {
              res[k].push(item)
            }
          })
        }
        this.favOptions = res
      } else {
        this.favOptions = JSON.parse(JSON.stringify(this.favAll))
      }
    },
    clear() {
      this.favName = ''
      this.keywords = ''
      this.addingId = ''
      this.loadFavs()
    },
    addChildFav(fav) {
      this.addingId = fav._id
    },
    addFav: async function(fav) {
      if (this.favName) {
        const param = { name: this.favName.trim() }
        if (fav.type === 'team') {
          param.type = 'team'
        }
        if (fav._id){
          param.parentId = fav._id
        }
        const res = await app.service('radish').addFavorite(param)
        if (res.status == 'success') {
          const id = res.data.id
          this.fids.unshift(id)
          this.favName = ''
          this.keywords = ''
          this.addingId = ''
          await this.loadFavs()
        }
      }
    },
    handleConfirm: async function() {
      this.dialogVisible = false
      this.onConfirm(this.fids)
    },
  },
}
</script>
<style scoped>
.add-fav-icon {
  cursor: pointer;
  font-weight: bold;
  position: absolute;
  right: 0;
  top: 0;
  background: #fff;
  color: #1A91FF;
  display: inline-block;
  height: 28px;
  line-height: 28px;
  width: 30px;
  text-align: center;
}
.fav-dia-label {
  position: relative;
  height: 26px;
  line-height: 26px;
  cursor: pointer;
  padding-right: 30px;
  overflow: hidden;
}
.fav-dia-label:hover, .fav-dia-label:hover > .add-fav-icon {
  background-color: #EBF5FF;
}
</style>